<template>
	<div ref='step'>
		<!-- 計算頁麵,産品明細 -->
		<template v-if='iscart==1'>
			<!-- <Row class="step" :gutter="4">
				<Col span='5' style='text-align: right;'>
				<Button :disabled='disabledSub' @click='modify("-")' class='step-btn' type='primary' size='large' icon='md-remove'>
				</Button>
				</Col>
				<Col span='7'>
				<Input class='step-Input' :disabled='IsRedeem' v-model='count' size='large' @on-focus="select" @on-change='updateValue'></Input>
				</Col>
				<Col span='5' style='text-align: left;'>
					<Button :disabled='disabledAdd' @click='modify("+")' class='step-btn' type='primary' size='large' icon='md-add'>
					</Button>
				</Col>
				<Col span='5' style='text-align: left;'>
					
				</Col>
			</Row> -->
			<div class="stepper2">
				<div class="button-primary sub" @click="remove">
					<Icon type="md-remove" />
				</div>
				<Input :value='number' class="detailInput" style='width: 70px;' size='small' @on-change='updateNumber'></Input>
				<div class="button-primary add" @click="add">
					<Icon type="md-add" />
				</div>
			</div>
			<Poptip v-model="visiable" padding='10px' :placement="placement">
				<Button class='rightBuy detail' type="default" @click.stop="distribution">加購物車&nbsp;&nbsp;Add to Cart</Button>
				<div slot="content" class="buyTip">
					成功添加{{number}}個商品
				</div>
			</Poptip>

		</template>
		<!-- PC版本右側 -->
		<template v-else-if='iscart==0'>
			<div class="stepper buyCart">
				<div class="button-primary sub" @click.stop='modify("-")'>
					<Icon type="md-remove" />
				</div>
				<Input :value='count' :disabled='IsRedeem' @on-focus="select" @on-change='updateValue' style='width: 40px;' size='small'></Input>
				<div class="button-primary add" @click.stop='modify("+")'>
					<Icon type="md-add" />
				</div>
			</div>
		</template>
		<!-- 移動版購物車 -->
		<template v-else-if='iscart==3'>
			<div class='mobile_step'>
				<span>
					<Button :disabled='disabledSub' shape="circle" class='step-btn1' @click='modify("-")' type='primary' icon='minus-round'>
					</Button>
				</span>
				<span class='cart_num'>
					{{count}}
				</span>
				<span>
					<Button :disabled='disabledAdd' shape="circle" class='step-btn1' @click='modify("+")' type='primary' icon='plus-round'>
					</Button>
				</span>
			</div>

		</template>
		<!-- 立即結算 -->
		<template v-else-if='iscart==10'>
			<Button :loading='false' class='savefirst' type='primary' @click='confrimfirst' long>立即結算</Button>
		</template>
		<!-- 手機版購物車 -->
		<template v-else-if='iscart==2'>
			<div class="stepper1">
				<div class="button-primary sub" @click="remove" @click.stop='modify("-")'>
					<Icon type="md-remove" />
				</div>
				<Input :value='count' :disabled='IsRedeem' @on-focus="select" @on-change='updateValue' style='width: 40px;' size='small' ></Input>
				<div class="button-primary add" @click="add" @click.stop='modify("+")'>
					<Icon type="md-add" />
				</div>
			</div>
		</template>
		<!-- 産品列錶 -->
		<template v-else-if='iscart==4'>
			<div class="stepper1">
			
				<div class="button-primary sub" @click="remove">
					<Icon type="md-remove" />
				</div>
				<Input :value='number' style='width: 40px;' size='small' @on-change='updateNumber'></Input>
				<div class="button-primary add" @click="add">
					<Icon type="md-add" />
				</div>
			</div>
			<Poptip v-model="visiable" padding='10px' style="float: right;" :placement="placement">
				<Button   class='rightBuy' type="default" shape="circle" @click.stop="distribution">加購物車&nbsp;&nbsp;Add to Cart</Button>
				
				<Button   class='rightBuy_mobile' type="default" shape="circle" @click.stop="distribution"><Icon  class="rightBuy_icon" type="ios-cart" size='20'></Icon></Button>
			
				<div slot="content" class="buyTip">
					成功添加{{number}}個商品
				</div>
			</Poptip>

		</template>
	</div>
</template>

<script>
import * as LMG from "@/assets/js/msg.js";
import {
	promoteMethods,
	productLimtMethods,
	userInfoOrderMethods,
	promoCodeMethods
} from "@/components/common/mixin";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
	data() {
		return {
			disabledAdd: false,
			disabledSub: false,
			count: 0,
			showMoveDot: [],
			number: 1,
			visiable: false,
			maxNum: 500,
		};
	},
	props: {
		value: {
			type: Number,
			default: 0,
		},
		iscart: {
			type: Number,
			default: 0, //0代錶購物車 1代錶産品列錶 2代錶購物車
		},
		islrp: {
			type: Boolean,
			default: false,
		},
		lrpedit: {
			type: Boolean,
			default: false,
		},
		product: {
			type: Object,
			default: function () {
				return {};
			},
		},
		animete: {
			type: Boolean,
			default: false,
		},
		placement: {
			type: String,
			default: "right-end",
		},
	},
	created() {
		this.$nextTick(function () {
			this.initData();
		});
	},
	mounted() {},
	watch: {
		value(curValue, oldValue) {
			this.count = curValue;

			if ((this.disabledSub = curValue <= 0)) {
				//this.value = 0
			}
			if ((this.disabledAdd = curValue >= this.limit)) {
				//this.$emit('input', this.limit)
			}
			// this.count = curValue;
		},
		number(curValue, oldValue) {
			if(curValue > 5){
				this.number = 5
			}
		},
	},
	mixins: [userInfoOrderMethods, promoteMethods, productLimtMethods,promoCodeMethods],
	components: {},
	computed: {
		...mapState({
			unSave: (state) => state.lrporder.unSave,
			newpromoCode: (state) => state.order.newpromoCode,
			cartInfo: (state) => state.order.cartInfo,
			carlrptInfo: (state) => state.lrporder.cartInfo,
			userInfo: (state) => state.common.wechatUserInfo,
			isBuy: (state) => state.lrporder.isBuy,
			promote: (state) => state.order.promote,
			birthdayLimt: (state) => state.order.birthdayLimt,
			productLimt: (state) => state.order.productLimt,
			warehouseInfo: (state) => state.order.warehouseInfo,
		}),
		warehouseList: function () {
			return [...((this.warehouseInfo || {}).value || {})];
		},
		shopCart: function () {
			return ((this.cartInfo || {}).value || {}).detail || [];
		},
		shopLRPCart: function () {
			return this.shopCart;
		},
		opshopCart: function () {
			if (this.islrp) {
				return this.shopLRPCart;
			}
			return this.shopCart;
		},
		IsRedeem: function () {
			let point = this.shopCart.filter((u) => u.sku == this.product.sku);

			if (point[0]) {
				return point[0].point > 0;
			}
			return false;
		},

		isFirstOrder: function () {
			let ui = { ...(((this.userInfo || {}).value || {}).binding || {}) };
			if (!ui.user_id) {
				return true;
			}
			if (ui && ui.first_order_status == 0) {
				return true;
			}
			return false;
		},
		isOriginalPrice: function () {
			let ui = { ...(((this.userInfo || {}).value || {}).binding || {}) };
			// if(this.forCustomer){
			//     if(this.forCustomer.customer_type=='rt') return true
			// }
			if (ui.customer_type && ui.customer_type.toLowerCase() == "rt") {
				return true;
			}
			return false;
		},
		lrpProductLimit: function () {
			var pv = 0;
			this.shopLRPCart.forEach((item, index) => {
				if (item.is_lrpt_product != 20 && item.num > 0) {
					pv += item.pv * item.num;
				}
			});
			return pv;
		},
		firstPromoCode: function () {
			var PromoCodeitem = null;
			Object.values(this.newpromoCode).forEach((item) => {
				PromoCodeitem = item;
			});
			return PromoCodeitem;
		},
		birthdayBuy: function () {
			var model = this.shopCart.filter((u) => u.product_flag == 10);
			if (model[0]) {
				return model[0];
			}
			return null;
		},
	},
	methods: {
		...mapActions([
			"checkPromoCodeAction",
			"updateCartAction",
			"getSpecInfoAction",
		]),
		...mapMutations([
			"ADD_CART",
			"REDUCE_CART",
			"EDIT_CART",
			"REDUCE_NEWPROMOCODE",
			"ADD_LRP_CART",
			"REDUCE_LRP_CART",
			"EDIT_LRP_CART",
			"REDUCE_LRP_NEWPROMOCODE",
			"SET_UNSAVE",
			"REDUCEALL_CART",
			"SET_PC_OR_RT_PREICE",
			"EDIT_CART1",
			"REDUCEALL_LRP_CART",
			"CLEAR_CART",
			"SET_NEWPROMOCODE",
			"REDUCEALL_LRP",
		]),
		add() {
			if (this.number >= this.maxNum) {
				return;
			}
			this.number++;
		},
		remove() {
			if (this.number <= 1) {
				return;
			}
			this.number--;
		},
		async initData() {
			this.count = this.product.num || 0;
			// this.value=this.count;
			if ((this.disabledSub = this.value <= 0)) {
				//this.$emit('input', 0)
			}
			// if (this.disabledAdd = this.value >= this.limit) {
			// 	//this.$emit('input', 5)
			// }
		},
		async distribution() {
			var op = false;
			let pn = this.getProductNum(this.product.sku);
			var num = this.number;
			console.log(num);
			if (pn == 0) {
				if (!(await this.add_cart(null, num))) return;
			} else if (!(await this.edit_cart(null, pn + num, true))) return;

			this.showPoptip();
		},
		showPoptip() {
			this.visiable = true;
			setTimeout(() => {
				this.visiable = false;
			}, 2000);
		},
		async modify(type) {
			var op = false;
			let pn = this.getProductNum(this.product.sku); // this.count;
			if (type == "+") {
				if (pn == 0) {
					if (!(await this.add_cart(null))) return;
				} else if (!(await this.edit_cart(null, pn + 1, true))) return;
				//pn++;
				op = true;
			} else if (type == "-") {
				if (!(await this.edit_cart(null, pn - 1, false))) return;

				//pn--;
			}
			//this.count=pn;
			if (this.animete && op) {
				let elLeft = event.target.getBoundingClientRect().left;
				let elBottom = event.target.getBoundingClientRect().bottom;
				this.$emit(
					"showMoveDotFun",
					[true],
					elLeft,
					elBottom,
					this.product.image_path_big
				);
			}
			return false;
		},
		getProductNum(sku) {
			let num = 0;
			let ths =
				this.opshopCart &&
				this.opshopCart.filter(function (item) {
					return item.sku == sku && item.num > 0;
				});
			if (ths[0]) num = ths[0].num;
			return num;
		},
		convtModel() {
			let obj = {};
			var item = this.product;
			var priceitem = item.specproducts[0];
			obj.category_id = item.category_id;
			obj.item_id = item.id;
			obj.product_id = item.id;
			obj.name = item.name;
			obj.price = this.isOriginalPrice
				? priceitem.original_price
				: priceitem.price;
			obj.rt_price = priceitem.original_price;
			obj.pc_price = priceitem.price;
			obj.pv = priceitem.pv;
			obj.pt = priceitem.pt;
			obj.specs = item.specs;
			obj.packing_fee = priceitem.packing_fee;
			obj.sku_id = item.sku;
			obj.sku = item.sku;
			obj.stock = item.stock;
			obj.is_promotion = item.is_promotion;
			obj.is_new = item.is_new;
			obj.is_lrpt_product = item.is_lrpt_product;
			obj.is_hot = item.is_hot;
			obj.product_flag = item.product_flag;
			return obj;
		},
		async check(e, pn, type) {
			if (type) {
				if (!this.checkBirthday(e, pn)) return false;

				if (pn > this.product.stock) {
					this.showTips("親愛的顧客，非常抱歉，庫存不足請重新選擇。");
					if (e) {
						e.target.value = this.product.stock;
					}
					return false;
				}
				if (
					this.productFirstOrderLimit &&
					this.productFirstOrderLimit.length > 0
				) {
					if (!this.isFirstOrder) {
						//非首單，禁止購買
						this.showTips(
							"親愛的顧客，非常抱歉，首購套裝網站僅限新註冊顧客購買。"
						);
						return false;
					} else {
						if (pn > this.productFirstOrderLimit[0].max_num) {
							this.showTips(
								"親愛的顧客，非常抱歉，首購套裝數量超過限製。"
							);
							if (e) {
								e.target.value = this.productFirstOrderLimit[0].max_num;
							}
							return false;
						}
					}
				}
				if (
					this.productOtherOrderLimit &&
					this.productOtherOrderLimit.length > 0
				) {
					if (pn > this.productOtherOrderLimit[0].max_num) {

						if(this.productOtherOrderLimit[0].by_level=='List'){
							this.showTips(
								this.productOtherOrderLimit[0].remark
							);
						}
						else{
							this.showTips(
								"親愛的顧客，非常抱歉，購買數量超過限製"
							);
						}
						if (e) {
							e.target.value = this.productOtherOrderLimit[0].max_num;
						}
						return false;
					}
				}
				if (this.product.promo_flag == 10) {
				}
				if (!this.checkLPT(e)) return false;
			}
			
			if (!this.islrp) {
				if (!(await this.isPromoteCode(e, type, pn, this.product)))
					return false;
			}
			return true;
		},
		checkBirthday(e, pn) {
			if (this.product.product_flag == 10) {
				if (pn > 1) {
					this.showTips(LMG.BD_MSG_0002, 5000);
					return false;
				}
				if (this.birthdayLimt == -1) {
					this.showTips(LMG.BD_MSG_0001, 5000);
					return false;
				} else if (this.birthdayLimt == 1) {
					this.showTips(LMG.BD_MSG_0002, 5000);
					return false;
				}
			}
			var model = this.birthdayBuy;
			if (model) {
				if (model.sku == this.product.sku) {
					this.showTips(LMG.BD_MSG_0002, 5000);
					return false;
				} 
			// 	else {
			// 		this.showTips(LMG.BD_MSG_0003, 5000);
			// 		return false;
			// 	}
			// } else if (this.product.product_flag == 10) {
			// 	this.CLEAR_CART();
			 }

			return true;
		},
		checkLPT(e) {
			var is_lrpt_product = this.product.is_lrpt_product;
			//輕鬆購判斷
			if (true) {
				if (is_lrpt_product == 11 || is_lrpt_product == 12) {
					if (this.getLRPType(is_lrpt_product)[0]) {
						if (e) e.target.value = 1;
						this.showTips(LMG.LRPT_MSG_0001, 5000);
						return false;
					}
					if (this.isBuy < 0) {
						if (this.isBuy == -2) {
							this.showTips(LMG.LRPT_MSG_0002, 5000);
						} else if (this.isBuy == -3) {
							this.showTips(LMG.LRPT_MSG_0008, 5000);
						} else {
							this.showTips(LMG.LRPT_MSG_0003, 5000);
						}
						return false;
					}
					var result_lrpt_product = is_lrpt_product == 11 ? 12 : 11;

					if (this.getLRPType(result_lrpt_product)[0]) {
						//是否存在該限製産品。

						this.showTips(LMG.LRPT_MSG_0004, 5000);
						return false;
					}
				}
				if (is_lrpt_product == 20) {
					//限製125點 --不包含産品
					if (this.getLRPType(20)[0]) {
						if (e) e.target.value = 1;
						this.showTips(LMG.LRPT_MSG_0005, 5000);
						return false;
					} else if (this.lrpProductLimit < 125) {
						this.showTips(LMG.LRPT_MSG_0006, 5000);
						return false;
					}
				}
			} else {
				if (is_lrpt_product == 11 || is_lrpt_product == 12) {
					if (e) e.target.value = 1;
					this.showTips(LMG.LRPT_MSG_0001);
					return false;
				}
				if (is_lrpt_product == 20) {
					if (e) e.target.value = 1;
					this.showTips(LMG.LRPT_MSG_0005);
					return false;
				}
			}
			return true;
		},
		async add_cart(e, num) {
			var pn = num || 1;
			if (!(await this.check(e, pn, true))) return false;

			let item = this.convtModel();
			let add_cart = this.islrp ? this.ADD_LRP_CART : this.ADD_CART;

			add_cart({ ...item, product_number: pn });
			if (this.lrpedit) {
				var obj = this.unSave;
				obj.cartInfo = true;
				this.SET_UNSAVE(obj);
			}
			if (!this.islrp) {
				this.IsPromoteTip(item.sku, pn || 0);
			}
			console.log("item---------------", item);
			this.updateCart(item.sku, pn);
			return true;
		},
		async edit_cart(e, value, type) {
			if (!(await this.check(e, value, type))) return false;
			var price = this.product.price;
			var sku = this.product.sku;

			var edit_cart = this.islrp ? this.EDIT_LRP_CART : this.EDIT_CART1;

			//檢測是否路由是購物車
			var canCart=false;
			if(this.$route.path=='/order/cart'){
				canCart=true;
			}
			var IsRedeem=this.IsRedeem
				

			edit_cart({ sku, num: value, price,canCart});

			if (true) {
				var item = this.getLRPType(20);
				if (item[0] && this.lrpProductLimit < 125) {
					this.showTips(LMG.LRPT_MSG_0007, 3000);
					this.REDUCEALL_LRP(item[0]);
				}
			}
			if (this.lrpedit) {
				var obj = this.unSave;
				obj.cartInfo = true;
				this.SET_UNSAVE(obj);
			}
			if (!this.islrp) {
				this.IsPromoteTip(sku, value);
			}

			//點數減少産品不調用更新購物車
			// if(IsRedeem&&!type){  //點數減少不調用API
			// 	console.log('觸發')
			// 	return true;
			// }
			this.updateCart(sku, value,type);
			return true;
		},
		select(e) {
			e.target.focus();
			e.target.select();
		},
		updateNumber(event) {
			this.$nextTick(() => {
				var number = parseInt(event.target.value) || 1;
				number = number > this.maxNum ? this.maxNum : number;
				this.number = number;
				event.target.value = number;
			});
		},
		updateValue(event) {
			this.$nextTick(async () => {
				let sku = this.product.sku;
				let pn = parseInt(event.target.value) || 0;
				if (pn > 0) {
					let model = null;

					if (this.islrp) {
						model = this.shopLRPCart.filter(
							(u) => u.sku == sku && u.num > 0
						)[0];
					} else {
						model = this.shopCart.filter(
							(u) => u.sku == sku && u.num > 0
						)[0];
					}

					if (model) {
						let result = pn >= model.num;
						if (!(await this.edit_cart(event, pn, result))) {
							event.target.value = model.num;
							this.count = model.num;
							return;
						}
					} else {
						if (!(await this.add_cart(event, pn, true))) {
							event.target.value = model.num;
							this.count = model.num;
							return;
						}
					}
				} else {
					if (!(await this.edit_cart(null, 0, false))) return;
				}

				this.count = pn;
				// this.$emit('input',this.count)
			});
		},
		async isPromoteCode(e, type, pn, products) {
			var sku = products.sku;
			if (type) {
				//加入購物車邏輯
				var promo = products.promolists[0] || {};
				let model = this.firstPromoCode;
				var newcode = this.getBySkufirstPromoCode(sku);
				var IsObj = Object.getOwnPropertyNames(this.newpromoCode)
					.length;

				if (model && !newcode) {
					if (model.mix_flag == 2) {
						this.showTips(
							"親愛的顧客，非常抱歉，您不能與普通産品混買哦<br>Dear Customers, sorry you can't order other regular products together"
						);
						return false;
					}
					if (model.mix_flag == 1 && model.code != promo.code) {
						this.showTips(
							"親愛的顧客，非常抱歉，您隻能選擇對應大會産品哦"
						);
						return false;
					}
					// if (products.promo_flag != 0 && model.code != promo.code) {
					// 	this.showTips(
					// 		"親愛的顧客，非常抱歉, 您不可與別的産品混買<br>Dear Customers, sorry you can't order others products together"
					// 	);
					// 	return false;
					// }
				}
				if (products.promo_flag == 1) {
					//this.showPromoCode(products)
					this.$emit("showPromoCode", products);
					if (e) {
						e.target.value = 0;
					}
					return false;
				}

				if (newcode) {
					if (pn > newcode.exchange_quantity) {
						this.showTips(
							"親愛的顧客，非常抱歉，超出優惠碼數量",
							5000
						);
						if (e) {
							// e.target.value= Number(newcode.exchange_quantity);
							// console.log(e.target.value)
						}
						return false;
					}
				}

				if (products.promo_flag == 2 && !newcode) {
					var params = {
						vipno: promo.code,
						code: null,
						sku,
					};
					this.$Spin.show({
						render: (h) => {
							return h("div", [
								h("Icon", {
									class: "demo-spin-icon-load",
									props: {
										type: "load-c",
										size: 18,
									},
								}),
								h("div", "Loading"),
							]);
						},
					});
					var res = await this.checkPromoCodeAction(params);
					this.$Spin.hide();
					if (res) {
						if (res.v.code > 0) {
							var newModel = res.v.data[0];

							if (newModel.mix_flag == 2) {
								this.CLEAR_CART();
							}
							if (newModel.mix_flag == 1 && !model) {
								this.CLEAR_CART();
							}
							this.SET_NEWPROMOCODE(newModel);
							return true;
						} else {
							this.showTips(res.v.msg);
							return false;
						}
					} else {
						this.showTips("係統發生異常,請重新嘗試");

						return false;
					}
				}
				if (products.promo_flag == 10) {
					var newPn = this.getProductNum(sku);
					if (newPn == 0) {
						var params = {
							res: sku,
							pcode: "csi002",
							category: "SKU"
						};
						this.$Spin.show({
							render: (h) => {
								return h("div", [
									h("Icon", {
										class: "demo-spin-icon-load",
										props: {
											type: "load-c",
											size: 18,
										},
									}),
									h("div", "Loading"),
								]);
							},
						});
						var res = await this.getSpecInfoAction(params);
						this.$Spin.hide();
						if (res) {
							let surveyProduct = this.convtModel();
							surveyProduct.product_number = pn;
							res.surveyProduct = surveyProduct;
							this.$emit("showSurveyfun", res);
							if (e) {
								e.target.value = 0;
							}
							return false;
						}
					}
				}
			} else {

				if (products.promo_flag == 1) {
					//this.showPromoCode(products)
					this.$emit("showPromoCode", products,1);
					if (e) {
						e.target.value = 0;
					}
					return false;
				}
			}

			return true;
		},
		async confrimfirst() {
			this.CLEAR_CART();
			if (await this.add_cart(null)) {
				this.$emit("confrimfirst");
			}
		},
		showTips(msg, s, model) {
			this.$Toast.show(msg, { duration: s || 1500 });
		},
		getLRPType(type) {
			//檢測某類型産品是否存在
			var res = this.shopLRPCart.filter(
				(u) => u.is_lrpt_product == type && u.num > 0
			);
			return res;
		},
		updateCart(sku, num) {
			var params = {
				//customerId:this.getUserId,
				sku,
				num,
			};
			this.updateCartAction(params);
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/mixin";
@import "@/style/common";
.buyTip {
	color: $theme-color;
}
.tipTitle {
	color: $theme-color;
	text-align: center;
}
.stepper {
	display: flex;
	float: left;
	height: 30px;
	.sub,
	.add {
		background-color: $theme-color;
		color: white;
		width: 30px;
		text-align: center;
		margin: 0 8px;
		border-radius: 5px;
	}
}
.stepper1 {
	display: flex;
	float: left;
	.sub,
	.add {
		background-color: $theme-color;
		color: white;
		width: 24px;
		text-align: center;
		margin: 0 5px;
		border-radius: 5px;
		@include fontSize($font-size-14);
	}
}

.stepper2 {
	display: flex;
	float: left;
	height: 35px;
	.sub,
	.add {
		background-color: $theme-color;
		color: white;
		width: 45px;
		text-align: center;
		margin: 0 5px;
		border-radius: 5px;
		@include fontSize($font-size-20);
	}
	.sub {
		margin-left: 0;
	}
}
.rightBuy {
	float: right;
	// width: 1.5rem;
	@include fontSize($font-size-14);
	border-color: $theme-color;
	border-width: 1.5px;
	color: $theme-color;
	position: relative;
	top: -3px;
	&.detail {
		height: 35px;
		top: 0px;
	}
}

.rightBuy_mobile{
	float: right;
	width: 1.07rem;
	@include fontSize($font-size-14);
	border-color: $theme-color;
	border-width: 1.5px;
	color: $theme-color;
	position: relative;
	top: -3px;
	display: none;
}

.step {
	padding-top: 0;
	width: inherit;
	margin-left: 0px;
	/*width: 220px;*/
	display: inline-block;
	.step-btn {
		font-size: 20px;
		width: 96%;
		height: 100%;
		padding: 2px 10px;
		margin: auto 2%;
	}
	.step-btn1 {
		@include fontSize($font-size-12);
		height: 25px;
		width: 25px;
	}
	// .step-number1{
	// 	font-size: 11px;
	// 	height: 25px;
	// 	//margin: 0 5px;
	// 	.ivu-input-large{
	// 		// font-size: 14px;
	// 	    // padding: 6px 7px;
	// 		// height: 26px;
	// 	}
	// }
}
.step-number1 .ivu-input {
	@include fontSize($font-size-14);
	height: 25px;
	text-align: center;
}

.cart_icon {
	width: 18px;
	height: 18px;
}
.cart_icon_container {
	//display: flex;
	display: inline-block;
	background-color: $theme-color;
	position: absolute;
	padding: 5px;
	border: 3px solid $theme-color;
	border-radius: 50%;
	cursor: pointer;
	//top: -20px;
	right: 0;
	top: -5px;
	// left: .5rem;
	// top: -.7rem;
	.cart_icon {
		width: 24px;
		height: 24px;
	}
}

.mobile_step {
	display: flex;
	align-items: center;
	height: 100%;
	span {
		display: flex;
		text-align: center;
		&.cart_num {
			font-size: 0.65rem;
			color: #666;
			min-width: 1rem;
			display: inline-block;
			text-align: center;
			font-family: Helvetica Neue, Tahoma;
		}
	}
	button {
		width: 0.9rem;
		height: 0.9rem;
		@include fontSize($font-size-14);
	}
}
.savefirst {
	height: 35px;
	border-right: 0;
}
@media (max-width: 768px){
	.rightBuy{
		display: none;
	}
	.fastBuy{
		.rightBuy_mobile{
			display: initial;
			.rightBuy_icon{
				position: relative;
				right:9px;
			}
		}
	}
	.stepper2 .sub{
		font-size: 1rem;
	}
	.stepper2 .add{
		font-size: 1rem;
	}
	
}
@media screen and (max-width: 1090px) {
	.cart_icon_container {
		top: -50px;
	}
}
.rightBuy_mobile{
	display: none;
}
</style>